import { render, staticRenderFns } from "./BancaEmaticaRichiesteRepartoViewComponent.vue?vue&type=template&id=64f5f632"
import script from "./BancaEmaticaRichiesteRepartoViewComponent.vue?vue&type=script&lang=js"
export * from "./BancaEmaticaRichiesteRepartoViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports